import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class AccountService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }

  getAllAccountsService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.accountServicesURLs.getAccounts,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAccountsByIdService = async (session_id, accountId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.accountServicesURLs.getAccounts +
          `accountId/${accountId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  createAccount = async (session_id, Account, cfg) => {
    const request = {
      accountName:
        Account.accountName == null
          ? Account.accountContactNumber
          : Account.accountName,
      accountContactName: Account.accountContactName,
      accountContactNumber: Account.accountContactNumber,
      accountContactEmail: Account.accountContactEmail,
      billingId: Account.billingId,
    };
    cfg && (request["accountConfiguration"] = cfg);
    try {
      return await this.HttpService.postJson(
        this.constants.accountServicesURLs.postAccount,
        request,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  deleteAccount = async (session_id, accountId) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.accountServicesURLs.getAccounts +
          `accountId/${accountId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  editAccount = async (session_id, Account) => {
    try {
      return await this.HttpService.putJson(
        this.constants.accountServicesURLs.editAccount,
        {
          accountId: Account.accountId,
          accountName:
            Account.accountName == null
              ? Account.accountContactNumber
              : Account.accountName,
          accountContactName:
            Account.accountContactName == null
              ? Account.accountName
              : Account.accountContactName,
          accountContactNumber: Account.accountContactNumber,
          accountContactEmail: Account.accountContactEmail,
          accountStatus: Account.accountStatus,
          // accountConfiguration: Account.cfg,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  upgradeOrDowngradeAccount = async (session_id, Account) => {
    try {
      return await this.HttpService.putJson(
        this.constants.accountServicesURLs.upgradeOrdowngradeAccount,
        {
          billingId: Account.billingId,
          pkgName: Account.pkgCode,
          accountId: Account.accountId,
          // accountId: Account.accountId,
          // accountName: Account.accountName,
          // accountContactName: Account.accountContactName,
          // accountContactNumber: Account.accountContactNumber,
          // accountContactEmail: Account.accountContactEmail,
          // accountStatus: Account.accountStatus,
          // cfg: Account.cfg,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  manageAccountNumbers = async (
    session_id,
    Account,
    assignedAccountNumbers
  ) => {
    try {
      return await this.HttpService.putJson(
        this.constants.accountServicesURLs.manageAccountNumbers,
        {
          accountId: Account.accountId,
          accountName: Account.accountName,
          accountContactName: Account.accountContactName,
          accountContactNumber: Account.accountContactNumber,
          accountContactEmail: Account.accountContactEmail,
          accountStatus: Account.accountStatus,
          assignedAccountNumbers: assignedAccountNumbers,
          accountConfiguration: Account.cfg,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  addBIVRNumbers = async (session_id, Account) => {
    try {
      return await this.HttpService.putJson(
        this.constants.accountServicesURLs.AddBIVRNumbers,
        {
          accountId: Account.accountId,
          BIVRNumbers: Account.BIVRNumbers,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAllAccountMSISDN = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.accountServicesURLs.getAllAccountMSISDN,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  viewAllAccountMSISDN = async (page,size,msisdn,session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.accountServicesURLs.viewListAccountMSISDN+`?page=${page}&size=${size}&msisdn=${msisdn}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  addAccountMSISDN = async (session_id, accountMSizeN) => {
    try {
      return await this.HttpService.postJson(
        this.constants.accountServicesURLs.addAccountMSISDN,
        accountMSizeN,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  deleteAccountMSISDN = async (session_id, msisdn) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.accountServicesURLs.deleteAccountMSISDN + `/${msisdn}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  deleteAccountNumber = async (session_id, msisdn) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.accountServicesURLs.deleteAccountNumber + `/${msisdn}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  deleteBIVRNumber = async (session_id, request) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.accountServicesURLs.deleteBIVRNumber,
        session_id,
        request
      );
    } catch (e) {
      throw e;
    }
  };

  getAdminDashboardData = async (session_id, accountId, from, to) => {
    try {
      return await this.HttpService.getJson(
        this.constants.accountServicesURLs.getAdminDashboardData +
          `/accountId/${accountId}` +
          `/from/${from}` +
          `/to/${to}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAdminBarsData = async (session_id, accountId, from, to) => {
    try {
      return await this.HttpService.getJson(
        this.constants.accountServicesURLs.getAdminBarsData +
          `/accountId/${accountId}` +
          `/from/${from}` +
          `/to/${to}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAdminLineGraphsData = async (session_id, accountId, from, to) => {
    try {
      return await this.HttpService.getJson(
        this.constants.accountServicesURLs.getAdminLineGraphsData +
          `/accountId/${accountId}` +
          `/from/${from}` +
          `/to/${to}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAgentGraphsData = async (session_id, from, to) => {
    try {
      return await this.HttpService.getJson(
        this.constants.accountServicesURLs.getAgentGraphsData +
          `/from/${from}` +
          `/to/${to}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAgentData = async (session_id, from, to) => {
    try {
      return await this.HttpService.getJson(
        this.constants.accountServicesURLs.getAgentData +
          `/from/${from}` +
          `/to/${to}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
}
